import NumberFormat from 'react-number-format'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Grid from '@material-ui/core/Grid'
import has from 'lodash/has'
import BacCardValueButton from './BacCardValueButton'
import FormHelperText from '@material-ui/core/FormHelperText'

const useStyles = makeStyles((theme) => ({
    cardValueSelectorContainer: {
        flexDirection: 'row',
        maxWidth: 470,
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
            margin: '0px',
        },
    },
    cardValueSelectorGridItemContainer: {
        padding: '4px 0 !important',
    },

    customValueInput: {
        width: '100%',
        maxWidth: '100%',
        height: '55px',
        borderRadius: '5px',
        border: '2px solid #9D9D9D',
        padding: '10px 14px 12px',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '1rem',
    },
    errorText: {
        marginTop: '0.25rem',
        color: theme.palette.error.main,
        [theme.breakpoints.up('md')]: {
            fontSize: '0.85rem',
        },
    },
    cardValueSelectorGridItem: {
        padding: '4px',
    },
}))

const BacCardValueSelector = ({
    fieldName,
    defaultCardValues,
    value,
    onValueChange,
    onBlur,
    errors,
    inputRef = null,
    isCurrency = false,
}) => {
    const classes = useStyles()

    const onCardValueChange = (event) => {
        const newValue = event?.value // For onValueChange of NumberFormat
            ? event.value
            : event // Default value selected from DefaultCardValueButton

        onValueChange(newValue)
    }

    return (
        <Grid
            container
            spacing={1}
            className={classes.cardValueSelectorContainer}
        >
            {defaultCardValues.map((defaultCardValue, index) => (
                <Grid
                    item
                    xs={3}
                    key={index}
                    className={classes.cardValueSelectorGridItem}
                >
                    <BacCardValueButton
                        defaultCardValue={defaultCardValue}
                        isSelected={value === defaultCardValue}
                        onValueChange={onCardValueChange}
                        isCurrency={isCurrency}
                    />
                </Grid>
            ))}

            <Grid
                item
                style={{
                    paddingTop: '8px',
                }}
                xs={12}
            >
                <NumberFormat
                    id={fieldName}
                    name={fieldName}
                    className={
                        classes.customValueInput + `${value ? ' selected' : ''}`
                    }
                    placeholder="Enter Amount"
                    label={null}
                    variant={'outlined'}
                    getInputRef={inputRef}
                    error={has(errors, fieldName) ? has(errors, fieldName) : ''}
                    value={value ? value.toString() : ''}
                    thousandSeparator={true}
                    prefix={isCurrency ? '$' : ''}
                    allowNegative={false}
                    allowLeadingZeros={false}
                    decimalScale={0}
                    onValueChange={onCardValueChange}
                    onBlur={onBlur}
                />
            </Grid>
            {errors[fieldName] && (
                <FormHelperText className={classes.errorText}>
                    {Array.isArray(errors[fieldName])
                        ? errors[fieldName].join(', ') // Convert array to a string safely
                        : errors[fieldName]}
                </FormHelperText>
            )}
        </Grid>
    )
}

export default BacCardValueSelector
